import '../../css/App.css'
import '../../css/PageTemplate.css'
import { useContext, useEffect } from 'react'
import { AppContext } from "../context/AppContext";
import { IAuth, IReplaceTrackerForm, IReplaceTrackerFormValidation } from '../../interfaces/interface';
import { IMessageSender, IMessageErrorResponse } from '../../interfaces/messageInterface';
import PopMessage from '../PopMessage/PopMessage';
import AddLoadSensorForm from './ReplaceTrackerForm';
import axios from 'axios';
import HeaderTemplate from '../HeaderTemplate';
import { ReplaceTrackerContext } from '../context/ReplaceTrackerContext';

function ReplaceTracker() {
  
  const { Form, formVal, blockField, errMessage, selectDefault} = useContext(ReplaceTrackerContext);
  const { navBarStatus, authorization, disMessage, navBarHandler, errorHandlerFunction } = useContext(AppContext);
  const [ auth ]: IAuth[] = authorization;
  const [isNavbarOpen] = navBarStatus;
  const navBarClickHandler: (e: any) => void = navBarHandler;
  const [formInput]: IReplaceTrackerForm[] = Form;     
  const [,setFormInput]: React.Dispatch<React.SetStateAction<IReplaceTrackerForm>>[] = Form;     
  const [displayMessage]: string[] = disMessage;
  const [,setDisplayMessage]: React.Dispatch<React.SetStateAction<string>>[] = disMessage;
  const [,setFormFieldsValid]:React.Dispatch<React.SetStateAction<IReplaceTrackerFormValidation>>[] = formVal;
  const [, setFieldBlock]: React.Dispatch<React.SetStateAction<boolean>>[] = blockField;
  const [, setDefaultSelect] = selectDefault;
  const [errorMessage]:string[] = errMessage;
  const [,setErrorMessage]: React.Dispatch<React.SetStateAction<string>>[] = errMessage;
  const errorHandler: (status: number) => string = errorHandlerFunction;
   
  const replaceTrackerHandler = (): void => {
    let messageBody:IMessageSender  = {
      type: 'replaceTracker',
      userId: auth.username,
      replaceTracker: {
        assetType: formInput.assetType,
        assetName: formInput.assetName,
        oldDeviceId: formInput.oldDeviceId,
        newDeviceId: formInput.newDeviceId,
      }
    }
    setDisplayMessage("processing");
    axios.post('/message',messageBody, auth.header
    ).then(res => {
      if (res.data.status === "OK"){
        setDisplayMessage("done");
        clearFields();
      } else {
        setErrorMessage(res.data.errorDescription)
        setDisplayMessage("error");
      }
    }).catch(({response}:IMessageErrorResponse) => {
      const errorMessage = errorHandler(response.data.status)
      setErrorMessage(errorMessage)
      setDisplayMessage("error");
    })
  }

  const clearFields = () => {
    setFieldBlock(false)
    setFormInput({
      assetName: "",
      assetType: "",
      oldDeviceId: "",
      newDeviceId: "",
      oldDeviceIdStatus:"",
    })
    setFormFieldsValid({     
      assetName: {
        isValid: false,
        displayMessage: false,
        message: ""
      },
      assetType: {
          isValid: false,
          displayMessage: false,
          message: ""
      },
      oldDeviceId: {
          isValid: false,
          displayMessage: false,
          message: ""
      },
      newDeviceId: {
          isValid: false,
          displayMessage: false,
          message: ""
      },
      oldDeviceIdStatus: {
          isValid: false,
          displayMessage: false,
          message: ""
      },
    })
    setDefaultSelect("")
  }
    
  return (
    <div className='page-template' onClick={navBarClickHandler}>
        <HeaderTemplate title="Replace Tracker" />
      <div className={(displayMessage !== "none" || isNavbarOpen === true)?'page-template-main blur': 'page-template-main'} onClick={navBarClickHandler}>
        <AddLoadSensorForm />
      </div>
      {displayMessage !== "none" && 
        <div className='page-template-pop-message'>
          <PopMessage 
            assetHandler={replaceTrackerHandler}
            formData={formInput}
            type={"general"}
            error={errorMessage}
          />
        </div>
      }
  </div>
  );
}

export default ReplaceTracker;


